import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import demographicsIconSrc from "../Media/mychart-demographics-icon.png";
import primaryCareProviderIconSrc from "../Media/mychart-primary-care-provider-icon.png";
import { FlexColumn, FlexRow } from "./common.styles";
import { addDisplayName } from "../Infra/display-name";
export const MissingMyChartPermissionCard = (props) => {
    const { t } = useTranslation(["patients"]);
    return (_jsxs(Card, { className: props.className, children: [_jsxs(HeaderRow, { alignItems: "center", gap: 12, children: [_jsx(CheckedBox, { children: _jsx(CheckIcon, { viewBox: "0 0 14 11", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z" }) }) }), _jsx(HeaderLabel, { children: t("Demographic Information") })] }), _jsxs(SubRows, { gap: 8, children: [_jsxs(SubRow, { alignItems: "center", gap: 8, children: [_jsx(IconSlot, { children: _jsx(DemographicsIcon, { src: demographicsIconSrc, alt: "" }) }), _jsx(SubRowLabel, { children: t("Demographics") })] }), _jsxs(SubRow, { alignItems: "center", gap: 8, children: [_jsx(IconSlot, { children: _jsx(PrimaryCareProviderIcon, { src: primaryCareProviderIconSrc, alt: "" }) }), _jsx(SubRowLabel, { children: t("Primary Care Provider") })] })] })] }));
};
addDisplayName(MissingMyChartPermissionCard, "MissingMyChartPermissionCard");
const Card = styled(FlexColumn) `
    padding: 20px 24px;
    gap: 12px;
    border: 2px solid ${colors.blue_10};
    border-radius: 12px;
    background-color: ${colors.white_main};
    align-self: center;
    align-items: flex-start;
`;
const HeaderRow = styled(FlexRow) `
    align-self: stretch;
`;
const HeaderLabel = styled.span `
    font-size: 16px;
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    line-height: 1.4;
`;
const SubRows = styled(FlexColumn) `
    padding-left: 32px;
`;
const SubRow = styled(FlexRow) ``;
const SubRowLabel = styled.span `
    font-size: 15px;
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_main};
    line-height: 1.4;
`;
const CheckedBox = styled.div `
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: ${colors.blue_50};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
const CheckIcon = styled.svg `
    width: 14px;
    height: 11px;
    fill: ${colors.white_main};
`;
const IconSlot = styled.div `
    width: 28.737px;
    height: 28.053px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
`;
const DemographicsIcon = styled.img `
    width: 28.737px;
    height: 24.632px;
`;
const PrimaryCareProviderIcon = styled.img `
    width: 24.632px;
    height: 28.053px;
`;
